<template lang="pug">
div
  fi-data-field(:label = '$t("reportingType")' :label-cols = 3 ) {{ classifierByCode('TYP_PRTCTN', immovableData.assetReportingType).human }}
  .flex-row-direction
    .loan-collateral-asset-immovable-fields-display.animated.fadeIn.margin-right-20.width-50
      fi-data-field(:label = '$t("registerNumber")') {{ immovableData.registerNumber }}
      fi-data-field(:label = '$t("type")') {{ classifierById('warrantyTypes', immovableData.warrantyTypeId).human }}
      fi-data-field(v-if   = 'isShowName'
                    :label = '$t("immovableName")') {{ immovableData.immovableName }}
      fi-data-field(:label = '$t("warrantyCadastralUnitIdentifier")') {{ immovableData.warrantyCadastralUnitIdentifier }}
      fi-data-field(:label = '$t("country")') {{ classifierById('countries', immovableData.warrantyCountryId).human }}
      fi-data-field(:label = '$t("county")') {{ classifierById('counties', immovableData.warrantyCountyId).human }}
      fi-data-field(:label = '$t("city")') {{ immovableData.warrantyCity }}
      fi-data-field(:label = '$t("address")') {{ immovableData.warrantyAddress }}
      fi-data-field(:label = '$t("postalСode")') {{ immovableData.warrantyPostalCode }}
      fi-data-field(:label = '$t("warrantyOwnerName")')
        .flex-column-direction
          table(v-if = 'immovableData.assetsOwners && immovableData.assetsOwners.length' style="width:100%")
            template(v-for = '(owner, index) in immovableData.assetsOwners')
              tr
                td.bold(style="border:none; padding:0px") {{ owner.customerName }}
          span.bold(v-else) {{ immovableData.warrantyOwnerName }}
      fi-data-field(:label = '$t("assetInfo")')
        .text(v-html = 'sanitizedText')
      fi-data-field(v-if = 'assetData.description' :label = '$t("description")')
        .text(style="white-space: pre-wrap") {{ assetData.description }}
      fi-data-field(:label = '$t("internalComment")')
        .text(v-html = 'sanitizedCommentText')
    div.width-50
      fi-data-field(:label = '$t("valueType")') {{ classifierByCode('TYP_PRTCTN_VL', immovableData.valueType).human }}
      fi-data-field(:label = '$t("valuationType")') {{ classifierByCode('PRTCTN_VLTN_APPRCH', immovableData.valuationType).human }}
      fi-data-field(:label = '$t("locationCode")') {{ classifierByCode('ISO3166_NUTS_DSJNT', immovableData.collateralLocationCode).human }}
      fi-data-field(:label = '$t("assetStatus")') {{ immovableData.assetStatus }}
      //- fi-data-field(:label = '$t("appraisalPartner")') {{ customerName(appraisalPartnerData) }}
      fi-data-field(:label = '$t("assetSoldValue")') {{ immovableData.assetSoldValue }}
      fi-data-field(:label = '$t("soldDate")') {{ $t('common:formatDate', { value: immovableData.soldDate }) }}
      fi-data-field(:label = '$t("warrantyArea")')
        .row
          .col {{ immovableData.warrantyArea }}
          .col {{ classifierById('immovableAreaSizeType', immovableData.areaSizeTypeId).human }}
      fi-data-field(:label = '$t("value")') {{ assetData.value | money }}
      fi-data-field(:label = '$t("valueDate")') {{ $t('common:formatDate', { value: assetData.valueDate }) }}
      fi-data-field(:label = '$t("allocatedValue")') {{ assetData.allocatedValue | money }}
      fi-data-field(:label = '$t("appraisalReport")') {{ assetData.appraisalReport ? $t('common:yes') : $t('common:no') }}
      template(v-if = 'assetData.appraisalReport')
        fi-data-field(:label = '$t("appraisalPartnerName")') {{ assetData.appraisalPartnerName }}
        fi-data-field(:label = '$t("appraisalValue")') {{ assetData.appraisalValue }}
      fi-data-field(:label = '$t("insuranceMandatory")') {{ assetData.insuranceMandatory ? $t('common:yes') : $t('common:no') }}
      fi-data-field(:label = '$t("insuranceCompany")') {{ assetData.insuranceCompany }}
        //- fi-data-field(:label = '$t("insuredUntil")') {{ $t('common:formatDate', { value: immovableData.collateralLocationCode }) }}
      fi-data-field(:label = '$t("insuredUntil")') {{ $t('common:formatDate', { value: assetData.insuredUntil }) }}
  .card.mt-3(v-if = 'parsedLandRegisterDetails')
    .card-header.land-register-result-header
      span {{ $t('landRegisterResult') }}
      small.text-muted(v-if = 'parsedLandRegisterDetails.inquiryDate')
        | {{ $t('landRegisterInquiryDate') }}: {{ formatInquiryDate(parsedLandRegisterDetails.inquiryDate) }}
    .card-body
      .mt-2(v-if = 'parsedLandRegisterDetails.properties && parsedLandRegisterDetails.properties.length')
        .bold {{ $t('landRegisterProperties') }}
        div(v-for = 'property in parsedLandRegisterDetails.properties' :key = 'property.cadastralCode + property.address')
          | {{ property.cadastralCode }} — {{ formatPropertyAddress(property.address) }}<span(v-if = 'property.postalCode')>, {{ property.postalCode }}</span><span(v-if = 'property.area')> — {{ property.area }} m²</span><span(v-if = 'property.intendedUse')> — {{ property.intendedUse }}</span>
      .mt-2(v-if = 'parsedLandRegisterDetails.owners && parsedLandRegisterDetails.owners.length')
        .bold {{ $t('landRegisterOwners') }}
        div(v-for = 'owner in parsedLandRegisterDetails.owners' :key = 'owner.code + owner.name')
          | {{ owner.name }}<span(v-if = 'owner.ownershipShare')> ({{ owner.ownershipShare }})</span>
      .mt-2(v-if = 'parsedLandRegisterDetails.encumbrances && parsedLandRegisterDetails.encumbrances.length')
        .bold {{ $t('landRegisterEncumbrances') }}
        .land-register-entry(v-for = 'entry in parsedLandRegisterDetails.encumbrances' :key = 'entry.entryNumber + entry.description')
          .land-register-entry-summary
            span {{ entry.type }}
            span(v-if = 'entry.beneficiary')  — {{ entry.beneficiary }}
          .land-register-entry-details(v-if = 'entry.description' v-html = 'sanitizeLandRegisterHtml(entry.description)')
      .mt-2(v-if = 'parsedLandRegisterDetails.mortgages && parsedLandRegisterDetails.mortgages.length')
        .bold {{ $t('landRegisterMortgages') }}
        .land-register-entry(v-for = 'mortgage in parsedLandRegisterDetails.mortgages' :key = 'mortgage.rankingOrder + mortgage.description')
          .land-register-entry-summary
            span {{ formatLandRegisterAmount(mortgage.amount) }} EUR
            span(v-if = 'mortgage.mortgagee && !containsHtml(mortgage.mortgagee)')  — {{ mortgage.mortgagee }}
          .land-register-entry-details(v-if = 'mortgage.mortgagee && containsHtml(mortgage.mortgagee)' v-html = 'sanitizeLandRegisterHtml(mortgage.mortgagee)')
          .land-register-entry-details(v-if = 'mortgage.description' v-html = 'sanitizeLandRegisterHtml(mortgage.description)')
      .text-muted.mt-2(v-if = '!hasLandRegisterRestrictions')
        | {{ $t('landRegisterNoRestrictions') }}
</template>


<script>
import FiDataField from '@/components/FiDataField'
import { mapGetters } from 'vuex'
import sanitizeHtml from 'sanitize-html'
import { customerName } from '@/helpers'

export default {
  name: 'loan-collateral-asset-immovable-fields-display',

  components: { FiDataField },

  props: {
    immovableData: {
      type: Object,
      required: true
    },
    assetData: {
      type: Object,
      required: true
    },
    appraisalPartnerData: {
      type: Object,
      default: null
    }
  },

  i18nOptions: {},

  computed: {
    ...mapGetters('classifiers', ['classifierById', 'classifierByCode']),
    sanitizedText () {
      return sanitizeHtml(this.assetData.assetInfo || '', {
        allowedTags: false,
        allowedAttributes: false,
        allowedSchemes: ['data', 'http'],
        nonTextTags: ['style', 'script', 'textarea', 'noscript']
      })
    },
    sanitizedCommentText () {
      return sanitizeHtml(this.assetData.comment || '', {
        allowedTags: false,
        allowedAttributes: false,
        allowedSchemes: ['data', 'http'],
        nonTextTags: ['style', 'script', 'textarea', 'noscript']
      })
    },
    parsedLandRegisterDetails () {
      const value = this.immovableData.landRegisterDetails
      if (!value) return null
      if (typeof value === 'object') return value
      try {
        return JSON.parse(value)
      } catch (error) {
        return null
      }
    },
    hasLandRegisterRestrictions () {
      return Boolean(this.parsedLandRegisterDetails && (this.parsedLandRegisterDetails.encumbrances?.length || this.parsedLandRegisterDetails.mortgages?.length))
    },
    isShowName () {
      return /land|lot/i.test(this.classifierById('warrantyTypes', this.immovableData.warrantyTypeId).code)
    }
  },
  methods: {
    customerName,
    sanitizeLandRegisterHtml (value) {
      return sanitizeHtml(value || '', {
        allowedTags: ['br', 'p', 'strong', 'em', 'u', 'span', 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
        allowedAttributes: {
          '*': ['class', 'style']
        },
        nonTextTags: ['style', 'script', 'textarea', 'noscript']
      })
    },
    containsHtml (value) {
      return /<\/?[a-z][\s\S]*>/i.test(value || '')
    },
    formatLandRegisterAmount (value) {
      if (value === null || value === undefined || value === '') return value
      return Number(value).toLocaleString(this.$i18n.locale, { maximumFractionDigits: 2 })
    },
    formatInquiryDate (value) {
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value
      const pad = number => String(number).padStart(2, '0')
      return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`
    },
    formatPropertyAddress (address) {
      return (address || '').replace(/,\s*$/, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-row-direction {
  display: flex;
}
.flex-column-direction {
  display: flex; flex-direction: column;
}
.bold {
  font-weight: bold;
  border: none !important;
}
.cursor-pointer {
  cursor: pointer;
}
.justify-content-space-evenly {
  justify-content: space-evenly;
}
.width-50 {
  width: 50%;
}
.margin-right-20 {
  margin-right: 20px
}
.land-register-entry {
  margin-top: 8px;
  padding: 10px 12px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  background: #fafbfc;
}
.land-register-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.land-register-entry-summary {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-weight: 500;
  line-height: 1.5;
}
.land-register-entry-details {
  margin-top: 8px;
  padding: 8px 10px;
  overflow-x: auto;
  border-left: 3px solid #6c8ebf;
  background: #fff;
  font-size: .92rem;
  line-height: 1.45;
}
.land-register-entry-details ::v-deep table {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
}
.land-register-entry-details ::v-deep td,
.land-register-entry-details ::v-deep th {
  padding: 6px 8px;
  border: 1px solid #e1e6eb;
  vertical-align: top;
  text-align: left;
}
.card-body {
  .bold {
    font-weight: bold;
  }
}
</style>


<i18n>
en:
  registerNumber:                  "Register number"
  type:                            "Immovable type"
  immovableName:                   "Immovable name"
  country:                         "Country"
  county:                          "County"
  city:                            "City"
  address:                         "Address"
  value:                           "Value"
  valueDate:                       "Value date"
  allocatedValue:        "Allocated value"
  appraisalReport:                 "Appraisal report"
  appraisalPartnerName:            "Appraisal partner"
  appraisalValue:                  "Appraisal value"
  insuranceMandatory:              "Insurance mandatory"
  insuranceCompany:                "Insurance company"
  insuredUntil:                    "Insured until"
  assetInfo:                       "Asset info"
  internalComment:                 "Internal comments"
  warrantyCadastralUnitIdentifier: "Cadastral unit identifier"
  warrantyArea:                    "Area"
  warrantyOwnerName:               "Owner name"
  postalСode:                      "Postal code"
  soldDate:                        "Sold date"
  assetSoldValue:                  "Asset sold value"
  appraisalPartner:                "Appraisal partner"
  reportingType:                   "Reporting type"
  valueType:                       "Value type"
  valuationType:                   "Valuation type"
  locationCode:                    "Location code"
  assetStatus:                     "Asset status"
  description:                     "Description"
  landRegisterResult:              "Land Register result"
  landRegisterInquiryDate:          "Inquiry date"
  landRegisterState:               "Status"
  landRegisterProperties:          "Properties"
  landRegisterOwners:              "Owners"
  landRegisterEncumbrances:        "Encumbrances and restrictions"
  landRegisterMortgages:           "Mortgages"
  landRegisterNoRestrictions:      "No mortgages or restrictions returned"
et:
  registerNumber:                  "Register number"
  type:                            "Immovable type"
  immovableName:                   "Immovable name"
  country:                         "Country"
  county:                          "County"
  city:                            "City"
  address:                         "Address"
  value:                           "Value"
  valueDate:                       "Value date"
  allocatedValue:        "Allocated value"
  appraisalReport:                 "Appraisal report"
  appraisalPartnerName:            "Appraisal partner"
  appraisalValue:                  "Appraisal value"
  insuranceMandatory:              "Insurance mandatory"
  insuranceCompany:                "Insurance company"
  insuredUntil:                    "Insured until"
  assetInfo:                       "Asset info"
  internalComment:                 "Internal comments"
  warrantyCadastralUnitIdentifier: "Cadastral unit identifier"
  warrantyArea:                    "Area"
  warrantyOwnerName:               "Owner name"
  postalСode:                      "Postal code"
  soldDate:                        "Sold date"
  assetSoldValue:                  "Asset sold value"
  appraisalPartner:                "Appraisal partner"
  reportingType:                   "Reporting type"
  valueType:                       "Value type"
  valuationType:                   "Valuation type"
  locationCode:                    "Location code"
  assetStatus:                     "Asset status"
  description:                     "Kirjeldus"
  landRegisterResult:              "Kinnistusraamatu tulemus"
  landRegisterInquiryDate:          "Päringu kuupäev"
  landRegisterState:               "Staatus"
  landRegisterProperties:          "Kinnistud"
  landRegisterOwners:              "Omanikud"
  landRegisterEncumbrances:        "Koormatised ja kitsendused"
  landRegisterMortgages:           "Hüpoteegid"
  landRegisterNoRestrictions:      "Hüpoteeke ega kitsendusi ei tagastatud"
ru:
  registerNumber:                  "Register number"
  type:                            "Immovable type"
  immovableName:                   "Immovable name"
  country:                         "Country"
  county:                          "County"
  city:                            "City"
  address:                         "Address"
  value:                           "Value"
  valueDate:                       "Value date"
  allocatedValue:        "Allocated value"
  appraisalReport:                 "Appraisal report"
  appraisalPartnerName:            "Appraisal partner"
  appraisalValue:                  "Appraisal value"
  insuranceMandatory:              "Insurance mandatory"
  insuranceCompany:                "Insurance company"
  insuredUntil:                    "Insured until"
  assetInfo:                       "Asset info"
  internalComment:                 "Internal comments"
  warrantyCadastralUnitIdentifier: "Cadastral unit identifier"
  warrantyArea:                    "Area"
  warrantyOwnerName:               "Owner name"
  postalСode:                      "Postal code"
  soldDate:                        "Sold date"
  assetSoldValue:                  "Asset sold value"
  appraisalPartner:                "Appraisal partner"
  reportingType:                   "Reporting type"
  valueType:                       "Value type"
  valuationType:                   "Valuation type"
  locationCode:                    "Location code"
  assetStatus:                     "Asset status"
  description:                     "Описание"
  landRegisterResult:              "Результат запроса"
  landRegisterInquiryDate:          "Дата запроса"
  landRegisterState:               "Статус"
  landRegisterProperties:          "Объекты недвижимости"
  landRegisterOwners:              "Собственники"
  landRegisterEncumbrances:        "Обременения и ограничения"
  landRegisterMortgages:           "Ипотеки"
  landRegisterNoRestrictions:      "Ипотеки и ограничения не найдены"
</i18n>
